import {__} from '../../../support/lang/translations.ts';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {Alignment} from '../../../enums/alignment.ts';

interface OwnProps {
    count: number;
}
export function OccasionResults({count}: OwnProps) {
    return (
        <FlexRow alignment={Alignment.Center}>
            <strong style={{padding: '1rem 0'}}>
                {count}
                {__(count === 1 ? 'occasions.index.titles.result' : 'occasions.index.titles.results')}
            </strong>
        </FlexRow>
    );
}
